import React from 'react';

export default function SessionTimeoutModal({ show, onStay, onLogout, secondsLeft }) {
  if (!show) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.3)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff', padding: 32, borderRadius: 8, boxShadow: '0 2px 16px #0002', minWidth: 320, textAlign: 'center'
      }}>
        <h3>Session Expiring Soon</h3>
        <p>Your session will expire in <b>{secondsLeft}</b> seconds due to inactivity or token expiry.</p>
        <p>Click <b>Continue</b> to stay logged in.</p>
        <div style={{ marginTop: 24 }}>
          <button onClick={onStay} style={{ marginRight: 16, padding: '6px 18px', background: '#007bff', color: '#fff', border: 'none', borderRadius: 4 }}>Continue</button>
          <button onClick={onLogout} style={{ padding: '6px 18px', background: '#f44336', color: '#fff', border: 'none', borderRadius: 4 }}>Logout</button>
        </div>
      </div>
    </div>
  );
}